module.exports = __webpack_public_path__ + "media/images/electricians-img-2-dccd4092cd0ee079fa6f7a7ce6f3ed44.jpg";